<script lang="ts">
import type { Map } from "maplibre-gl";
import { freshnessLabelForMap } from "../../lib/tileset.ts";
import StyleDetailRow from "./StyleDetailRow.svelte";

let { map }: { map: Map } = $props();

let label = $state<string | undefined>(undefined);
let freshnessRequestId = 0;

async function refreshFreshness(map: Map): Promise<void> {
  const requestId = ++freshnessRequestId;
  label = undefined;

  try {
    const text = await freshnessLabelForMap(map);

    if (requestId !== freshnessRequestId) return;

    label = text;
  } catch {
    if (requestId === freshnessRequestId) {
      label = "";
    }
  }
}

$effect(() => {
  map.on("style.load", refreshHandler);

  if (map.isStyleLoaded()) {
    void refreshFreshness(map);
  }

  return () => {
    map.off("style.load", refreshHandler);
  };
});

function refreshHandler(): void {
  void refreshFreshness(map);
}
</script>

<StyleDetailRow label="Map freshness" ariaLive="polite">
  {label === undefined ? "Loading..." : label || "Unknown for this style"}
</StyleDetailRow>
